import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { ScoringChart } from 'gnos-charts'
import _ from 'lodash'

import ToggleButton from '../../../../../../../../../../components/ToggleButton'
import DataTable from './DataTable'

import { LOCALE_PREFIX } from '../../../Blocks/PaymentIndex/constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Chart extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        chartDataTableActive: PropTypes.bool,
        customData: PropTypes.object,
        graphData: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        module: PropTypes.string.isRequired,
        paymentIndexChartToggleDataTable: PropTypes.func.isRequired,
        paymentIndexChartToggleSelector: PropTypes.func.isRequired,
        selector: PropTypes.string,
        tableData: PropTypes.array,
    }

    shouldComponentUpdate(nextProps) {
        const { block, chartDataTableActive, customData, graphData, tableData, id, module, selector } = this.props

        if (!_.isEqual(block, nextProps.block)) return true
        if (!_.isEqual(chartDataTableActive, nextProps.chartDataTableActive)) return true
        if (!_.isEqual(customData, nextProps.customData)) return true
        if (!_.isEqual(graphData, nextProps.graphData)) return true
        if (!_.isEqual(tableData, nextProps.tableData)) return true
        if (!_.isEqual(id, nextProps.id)) return true
        if (!_.isEqual(module, nextProps.module)) return true
        if (!_.isEqual(selector, nextProps.selector)) return true

        return false
    }

    handleToggleDataTable = (active) => {
        const { paymentIndexChartToggleDataTable, module, id, block, customData } = this.props

        paymentIndexChartToggleDataTable(module, id, block, { ...customData, chartDataTableActive: active })
    }

    handleToggleSelector = (active) => {
        const { paymentIndexChartToggleSelector, module, id, block, customData } = this.props

        paymentIndexChartToggleSelector(module, id, block, { ...customData, selector: active ? 'quarter' : 'year' })
    }

    render() {
        const { intl, graphData, id, chartDataTableActive, selector, tableData } = this.props

        if (_.isEmpty(graphData) || _.isEmpty(tableData)) return null

        return (
            <div className={'scoring-chart-container'}>
                <div className="title-container">
                    <FormattedMessage id={`${LOCALE_PREFIX}.paymentBehaviourDevelopment`} />
                </div>
                <div>
                    <div className={'chart-header'}>
                        <div className={'data-range-selector'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.yearPaymentIndex`} />
                            <ToggleButton
                                active={selector === 'quarter' || false}
                                arrows
                                onClickHandler={this.handleToggleSelector}
                            />
                            <FormattedMessage id={`${LOCALE_PREFIX}.quarterPaymentIndex`} />
                        </div>
                        <div className={'toggles'}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.dataTable`} />
                            <div className={'toggle-btn-container'}>
                                <ToggleButton
                                    active={chartDataTableActive || false}
                                    inactiveGreyBackground
                                    onClickHandler={this.handleToggleDataTable}
                                    textOff={intl.formatMessage({ id: `${LOCALE_PREFIX}.no` })}
                                    textOn={intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={'chart-container'}>
                        <ScoringChart
                            key={`payment-informations-scoring-chart-${id}`}
                            style={{ height: '751px', width: '100%', marginBottom: '-14px' }}
                            dataProvider={graphData}
                            dateFormat={'DD-MM-YYYY'}
                            automaticScale
                            reversedScale
                            showLegend
                            showValueAxisBaloon
                            categoryField={'startDate'}
                            graphs={[
                                {
                                    id: 'payment-morale-graph-1',
                                    title: intl.formatMessage({ id: `${LOCALE_PREFIX}.firm` }),
                                    type: 'line',
                                    dataSelector: 'index',
                                    lineColor: '#29ABE2',
                                    lineThickness: 1,
                                    fillAlphas: 0,
                                    negativeLineColor: '#29ABE2',
                                    negativeFillAlphas: 0,
                                    balloonColor: '#29ABE2',
                                    balloonTextColor: '#FFFFFF',
                                    fillColors: '#29ABE2',
                                    negativeFillColors: '#29ABE2',
                                    balloonBorderColor: '#29ABE2',
                                    balloonBorderThickness: 0,
                                    balloonTexts: [
                                        {
                                            label: intl.formatMessage({ id: `${LOCALE_PREFIX}.daysAfterDue` }),
                                            dataSelector: 'index',
                                        },
                                    ],
                                },
                                {
                                    id: 'payment-morale-graph-2',
                                    title: intl.formatMessage({ id: `${LOCALE_PREFIX}.sector` }),
                                    type: 'line',
                                    dataSelector: 'sectorIndex',
                                    lineColor: '#662D91',
                                    lineThickness: 1,
                                    fillAlphas: 0,
                                    negativeLineColor: '#662D91',
                                    negativeFillAlphas: 0,
                                    balloonColor: '#662D91',
                                    fillColors: '#662D91',
                                    negativeFillColors: '#662D91',
                                    balloonBorderColor: '#662D91',
                                    balloonTextColor: '#FFFFFF',
                                    balloonBorderThickness: 0,
                                    balloonTexts: [
                                        {
                                            label: intl.formatMessage({ id: `${LOCALE_PREFIX}.daysAfterDue` }),
                                            dataSelector: 'sectorIndex',
                                        },
                                    ],
                                },
                            ]}
                            monthNames={[
                                intl.formatMessage({ id: 'global.january' }),
                                intl.formatMessage({ id: 'global.february' }),
                                intl.formatMessage({ id: 'global.march' }),
                                intl.formatMessage({ id: 'global.april' }),
                                intl.formatMessage({ id: 'global.may' }),
                                intl.formatMessage({ id: 'global.june' }),
                                intl.formatMessage({ id: 'global.july' }),
                                intl.formatMessage({ id: 'global.august' }),
                                intl.formatMessage({ id: 'global.september' }),
                                intl.formatMessage({ id: 'global.october' }),
                                intl.formatMessage({ id: 'global.november' }),
                                intl.formatMessage({ id: 'global.december' }),
                            ]}
                            additionalPanel
                            additionalPanelData={[
                                {
                                    id: 'payment-morale-panel-1',
                                    dataSelector: 'totalAmountOfInvoices',
                                    title: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.totalAmountOfInvoices` })}`,
                                    balloonTexts: [
                                        {
                                            label: `${intl.formatMessage({
                                                id: `${LOCALE_PREFIX}.totalAmountOfInvoices`,
                                            })}: `,
                                            dataSelector: 'totalAmountOfInvoices',
                                            postfix: ` ${intl.formatMessage({
                                                id: `global.currency.${graphData[0].currency || 'CZK'}`,
                                            })}`,
                                        },
                                    ],
                                },
                                {
                                    id: 'payment-morale-panel-2',
                                    dataSelector: 'numberOfInvoices',
                                    title: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfInvoices` })}`,
                                    balloonTexts: [
                                        {
                                            label: `${intl.formatMessage({
                                                id: `${LOCALE_PREFIX}.numberOfInvoices`,
                                            })}: `,
                                            dataSelector: 'numberOfInvoices',
                                        },
                                    ],
                                },
                                {
                                    id: 'payment-morale-panel-3',
                                    dataSelector: 'numberOfSuppliers',
                                    title: `${intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfSuppliers` })}`,
                                    balloonTexts: [
                                        {
                                            label: `${intl.formatMessage({
                                                id: `${LOCALE_PREFIX}.numberOfSuppliers`,
                                            })}: `,
                                            dataSelector: 'numberOfSuppliers',
                                        },
                                    ],
                                },
                            ]}
                        />
                    </div>
                    {chartDataTableActive && (
                        <div className={'table-container'}>
                            <DataTable id={id} selector={selector} data={tableData} />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
